<template>
	<el-dialog v-dialogDrag class="im-dialog-shell im-dialog-shell--sm im-dialog-shell--mobile-center" title="是否加入通话?" :visible.sync="isShow" width="400px">
		<div class="rtc-group-join">
			<div class="host-info">
				<head-image :name="rtcInfo.host.nickName" :url="rtcInfo.host.headImage" :size="80"></head-image>
				<div class="host-text">{{ '发起人:' + rtcInfo.host.nickName }}</div>
			</div>
			<div class="users-info">
				<div>{{ activeUsers.length + '人正在通话中' }}</div>
				<div class="user-list">
					<div class="user-item" v-for="user in activeUsers" :key="user.id">
						<head-image :url="user.headImage" :name="user.nickName" :size="40">
						</head-image>
					</div>
				</div>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="onCancel()">取 消</el-button>
			<el-button type="primary" @click="onOk()">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import HeadImage from '@/components/common/HeadImage'

export default {
	name: "rtcGroupJoin",
	components: {
		HeadImage
	},
	data() {
		return {
			isShow: false,
			rtcInfo: {
				host: {},
				userInfos: []
			}
		}
	},
	props: {
		groupId: {
			type: Number
		}
	},
	computed: {
			activeUsers() {
				const users = Array.isArray(this.rtcInfo.userInfos) ? this.rtcInfo.userInfos : [];
			return users.filter(user => user && user.id && (user.mediaReady || user.mediaUserId));
			}
		},
	methods: {
		open(rtcInfo) {
			this.rtcInfo = rtcInfo;
			this.isShow = true;
		},
		onOk() {
			this.isShow = false;
			let userInfos = this.rtcInfo.userInfos.map(user => ({ ...user }));
			let mine = this.userStore.userInfo;
			if (!userInfos.find((user) => user.id == mine.id)) {
				// 加入自己的信息
				userInfos.push({
					id: mine.id,
					nickName: mine.nickName,
					headImage: mine.headImageThumb,
					isCamera: false,
					isMicroPhone: true,
					isShareScreen: false,
				})
			}
			let rtcInfo = {
				callId: this.rtcInfo.callId,
				isHost: false,
				groupId: this.groupId,
				inviterId: mine.id,
				userInfos: userInfos
			}
			// 通过home.vue打开多人视频窗口
			this.$eventBus.$emit("openGroupVideo", rtcInfo);

		},
		onCancel() {
			this.isShow = false;
		}
	}
}
</script>

<style lang="scss" scoped>
.rtc-group-join {
	display: grid;
	gap: 14px;
	padding: 4px 0 2px;
	min-height: 0;

	.host-info {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 10px;
		padding: 16px 12px 14px;
		border-radius: 16px;
		background: rgba(var(--im-primary-rgb), 0.05);

		.host-text {
			font-size: 14px;
			font-weight: 600;
			color: var(--im-text-color);
		}
	}

	.users-info {
		padding: 0 4px;
		font-size: 13px;
		color: var(--im-text-color-light);

		.user-list {
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			gap: 8px;
			margin-top: 10px;

			.user-item {
				display: inline-flex;
				padding: 2px;
			}
		}
	}
}
</style>
